<mat-drawer-container autosize>
  <mat-drawer position="start"
    mode="side"
    [opened]="opened"
    [class.open]="isOpen()"
    class="list-density-settings-3">
    <mat-nav-list class="categorie-navigatie">

      <mat-list-item (click)="toggleOpen()">
        <mat-icon matListItemIcon>
          {{isOpen() ? 'close_fullscreen' : 'open_in_full'}}
        </mat-icon>
        @if (isOpen()) {
          <div matListItemTitle>Minimaliseer</div>
        }
      </mat-list-item>
      <mat-divider></mat-divider>

      <div class="icon-navigatie"
        [class.closed]="!isOpen()">
        @if (isOpen()) {
          <div mat-subheader class="subheader">Ga naar</div>
        }
        <mat-list-item (click)="onStopClicked()">
          <mat-icon matListItemIcon
            fontSet="material-icons-outlined">
            stop_circle
          </mat-icon>
          @if (isOpen()) {
            <div matListItemTitle>Stop prestatie</div>
          }
        </mat-list-item>
        <mat-list-item (click)="onDienstenClicked()">
          <mat-icon matListItemIcon
            fontSet="material-icons-outlined">
            compare_arrows
          </mat-icon>
          @if (isOpen()) {
            <div matListItemTitle>Kies dienst</div>
          }
        </mat-list-item>
      </div>
      <mat-divider></mat-divider>

      <div class="icon-navigatie"
        [class.closed]="!isOpen()">
        @if (isOpen()) {
          <div mat-subheader class="subheader">Cliënt</div>
        }
        <mat-list-item (click)="onMeldingenClicked()">
          <mat-icon matListItemIcon
            fontSet="material-icons-outlined">
            contact_mail
          </mat-icon>
          @if (isOpen()) {
            <div matListItemTitle>Meldingen</div>
          }
        </mat-list-item>
        <mat-list-item (click)="onSignaalkaartenClicked()">
          <mat-icon matListItemIcon
            fontSet="material-icons-outlined">
            assignment
          </mat-icon>
          @if (isOpen()) {
            <div matListItemTitle>Signaalkaarten</div>
          }
        </mat-list-item>
        <mat-list-item (click)="onClientFicheClicked()">
          <mat-icon matListItemIcon
            fontSet="material-icons-outlined">
            description
          </mat-icon>
          @if (isOpen()) {
            <div matListItemTitle>Cliëntfiche</div>
          }
        </mat-list-item>
      </div>
      <mat-divider></mat-divider>

      @for (taakType of dienst.getTaakTypes(); track taakType; let isLast = $last) {
        <div class="icon-navigatie"
          [class.closed]="!isOpen()">
          @if (isOpen()) {
            <div mat-subheader class="subheader">{{taakType | titlecase}}</div>
          }
          @for (categorie of dienst.getCategorieenByType(taakType); track categorie) {
            <mat-list-item
              (click)="selectCategory(taakType, categorie)"
              [class.active]="isSelected(taakType, categorie)">
              <mat-icon matListItemIcon fontSet="material-icons-outlined"[ngClass]="categorie.getIcoon()"></mat-icon>
              @if (isOpen()) {
                <div matListItemTitle>{{categorie.getLabel()}}</div>
              }
            </mat-list-item>
          }
        </div>
        @if (!isLast) {
          <mat-divider></mat-divider>
        }
      }
    </mat-nav-list>
  </mat-drawer>
  <mat-drawer-content>
    <ng-content></ng-content>
  </mat-drawer-content>
</mat-drawer-container>
